export default {
  all (context) {
    var params = {
      page: context.page,
      order: context.order
    }
    context.loading = true
    context.$http.get('devices', {params: params}).then(response => {
      context.devices = response.body.data
      context.pagination = response.body.metadata.pagination
      context.loading = false
    })
  },
  get (context, id) {
    context.$http.get('devices/' + id).then(response => {
      context.device = response.body.data[0]
    })
  },
  sessions (context, deviceID) {
    context.$http.get('devices/' + deviceID + '/sessions').then(response => {
      context.sessions = response.body.data
    })
  },
  usageRights (context, deviceID) {
    return context.$http.get('devices/' + deviceID + '/usage_rights')
  },
  revision (context, deviceID) {
    context.$http.get('devices/' + deviceID + '/revisions').then(response => {
      context.revision = response.body.data[0]
    })
  },
  bumpRevision (context, deviceID) {
    return context.$http.post('devices/' + deviceID + '/revisions/bump')
  },
  toggleUsageRight (context, deviceID, usageRightID) {
    return context.$http.post('devices/' + deviceID + '/usage_rights/' + usageRightID + '/toggle')
  },
  destroyUsageRight (context, deviceID, usageRightID) {
    return context.$http.delete('devices/' + deviceID + '/usage_rights/' + usageRightID)
  },
  expireUsageRight (context, deviceID, usageRightID, endDate) {
    var body = {end_date: endDate}
    return context.$http.post('devices/' + deviceID + '/usage_rights/' + usageRightID + '/expire', body)
  },
  migrateUsageRight (context, deviceID, usageRightID) {
    return context.$http.put('devices/' + deviceID + '/usage_rights/' + usageRightID + '/migrate')
  },
  destroy (context, deviceID) {
    return context.$http.delete('devices/' + deviceID)
  },
  search (context, term, options) {
    return context.$http.post('devices/search', {term: term}, options)
  }
}



// WEBPACK FOOTER //
// ./src/services/devices.js